import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lateral-buttons',
  templateUrl: './lateral-buttons.component.html',
  styleUrls: ['./lateral-buttons.component.css']
})
export class LateralButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
